import { useState, useRef, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Grid, Container, Typography } from '@material-ui/core'

import Dialog, { DialogType } from '../control/dialog/dialog'
import useLoading from '../control/loading/useLoading'

import useApproveExReseacher, { FormT } from '../services/um/useApproveExResearcher'
import useTranslate from '../i18n/useTranslate'
import useAuthenStore from '../stores/authen/authenStore'

import Form from '../component/um/approve-external-researcher/Form'
import StatusBar from '../component/um/approve-external-researcher/StatusBar'
import { decryptionAES } from '../utilities/encryption'

const ApproveExResearcher = () => {
    const history = useHistory()
    const translate = useTranslate()
    const authenStore = useAuthenStore()
    const params = useParams<{ id: string }>()
    const { get, put } = useApproveExReseacher()
    const loadingHook = useLoading()

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const [init, setInit] = useState<FormT>()

    useEffect(() => {
        fetch()
    }, [])

    const fetch = async () => {
        const result = await get(decryptionAES(params.id))

        if (result.userID) {
            setInit(result)
        }
    }

    const save = async (values: FormT) => {
        loadingHook.loadingOpen()
        const result = await put(
            {
                email: values.email,
                nameTH: values.nameTH,
                nameEN: values.nameEN,
                statusID: Number(values.result || 1),
                updateBy: String(authenStore.profile.userId),
                reasonReject: values.reasonReject ?? '',
                departments: values.departments,
                langReason: values.result === '2' ? '' : values.langReason,
            },
            decryptionAES(params.id),
        )

        if (result.message === 'success') {
            loadingHook.loadingClose()
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                type: 'alert-message',
                onAfterClose: onBack,
            })
        }

        if (result.message !== 'success') {
            loadingHook.loadingClose()
            setConfigDialog({
                title: translate.get('ALERT.TITLE.ERROR'),
                content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                type: 'alert-message',
            })
        }
    }

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const onSubmit = (values: FormT) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => save(values),
        })

        dialogTwoRef.current?.openDialog()
    }

    const onBack = () => {
        history.goBack()
    }

    const renderForm = () => {
        if (init) {
            return (
                <>
                    <StatusBar id={init.status} reason={init.reasonReject} />
                    <Form onSubmit={onSubmit} onBack={onBack} initial={init} />
                </>
            )
        }
    }

    return (
        <Container maxWidth="lg">
            <Grid container>
                <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                    {translate.get('UM.APPROVE-RESEARCHER.MENU')}
                </Typography>
                {renderForm()}
                <Dialog onRef={onRefDialogTwo} {...configDialog} />
            </Grid>
        </Container>
    )
}

export default ApproveExResearcher
